$(() => {
  $(".variant-switcher--close").on("click", (event) => {
    event.preventDefault()
    Cookies.set("suppress_switch_to_opposite_variant_banner", "true")
    $(event.currentTarget).parent().addClass("variant-switcher_hidden")
  })
})
